import { isEmpty, isNil, reject } from 'ramda';

const queryString = {
    parse: (query: string) => {
        if (!URLSearchParams) return {};
        const searchParams = new URLSearchParams(query);

        return Array.from(searchParams).reduce((obj: any, [key, value]: [string, string]) => {
            return { ...obj, [key]: value };
        }, {});
    },
    stringify: (paramsObj: any) => {
        const params = reject((obj) => isNil(obj) || isEmpty(obj), paramsObj);
        if (!URLSearchParams) return '';
        const searchParams = new URLSearchParams(params);

        return searchParams.toString();
    }
};

export default queryString;
